export default __webpack_public_path__ + "static/media/signup.e9f76630.png";